
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";

import { BsInfoCircle } from 'react-icons/bs';
import { formatDateToShortMonth } from '../ChallengeDetails/View';
import { htmlToPlainText } from 'services/RequestUtils';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '1rem 0 2rem 0',
    padding: '1rem',
    background: '#fff',
  },
  title: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1.25rem',
    marginBottom: '1rem',
    color: '#333',
  },
  subtitle: {
    fontFamily: 'VodafoneRg-regular',
    fontSize: '1rem',
    color: '#9b9494',
    marginBottom: '2rem',
  },
  section: {
    marginTop: '2rem',
  },
}));

// const htmlToPlainText = (htmlString) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(htmlString, 'text/html');
//   return doc.body.textContent || "";
// };

 
export const ChallengePreview = (props) => {

  const classes = useStyles();
  const { formData, isAdmin , isInnovator, userEmail,innovateCategoryTypes, selectedUsers} = props || {}
  // console.log("🚀 ~ ChallengePreview ~ formData:", formData)
  // const showEmail = isAdmin ? userEmail : 'N/A'

  // const updatedUsers = isInnovator && !isAdmin && userEmail
  // ? [...selectedUsers, { value: userEmail }]
  // : selectedUsers;


const finalUsers = Array.from(
  new Map(
    [
      ...(selectedUsers || []),
      ...[{ value: userEmail, label: userEmail }]
    ].map(item => {
      const value = item.value || item.label; // fallback safety

      return [
        value?.toLowerCase(),
        {
          ...item,
          value,
          label: item.label || value // ✅ ensure label always exists
        }
      ];
    })
  ).values()
);

  // const organizerEmails = [...new Set(updatedUsers.map(u => u.value))];

  // console.log("organizerEmails==>", organizerEmails)

  if (!formData) return null;

  const {
    title,
    summary,
    category,
    startingDate,
    closingDate,
    termsAndConditions,
    coverPhoto,
    templateIdea,
    templateScorecard,
    communities,
  } = formData;
  
  const selectedType = innovateCategoryTypes.find(
    (type) => +type.id === +category
  );


const htmlSummary = htmlToPlainText(summary)
const htmlTermsAndConditions = htmlToPlainText(termsAndConditions)

  
  const startDataFormat = formatDateToShortMonth(startingDate)
  const endDataFormat = formatDateToShortMonth(closingDate)
  const sections = [
    {
      title: 'Challenge Details',
      subtitle: 'Basic information about your challenge',
      data: [
        { label: 'Challenge Title', value: title },
        { label: 'Challenge Description', value: htmlSummary },
        { label: 'Category', value: selectedType?.name },
        { label: 'Submission Start Date', value: startDataFormat },
        { label: 'Submission End Date', value: endDataFormat },
        { label: 'Challenge Cover Photo', value: coverPhoto || 'N/A' },
        { label: 'Terms and Conditions', value: htmlTermsAndConditions },
      ],
    },
    {
      title: 'Idea Template Selection',
      subtitle: 'Details of the selected idea template',
      data: [
        { label: 'Selected Idea Template Name', value: templateIdea || 'N/A' },
      ],
    },
    {
      title: 'Evaluation Workflow',
      subtitle: 'Details of the selected scorecard template',
      data: [
        { label: 'Evaluation Method', value: 'Scorecard' },
        { label: 'Selected Scorecard Template Name', value: templateScorecard || 'N/A' },
      ],
    },
    {
      title: 'Owner & Communities',
      subtitle: 'Challenge ownership and participation settings',
      data: [
        { label: 'is Admin', value: isAdmin },
        { label: 'Challenge Owner', value: userEmail }, 
        {label:'Co-orgnizer', value: finalUsers },
        // { label: 'Approval Settings', value: 'True' }, // Replace with dynamic value if available
        { label: 'Communities', value: communities || 'N/A' },
      ],
    },
  ];

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>Challenge Summary</h2>
      <p className={classes.subtitle}>Review your challenge details before submitting</p>

      {sections.map((section,i) => (
        <PreviewSection key={section.title || i} {...section} />
      ))}

      <div className={classes.section}>
        <h3 className={classes.title}>Ready to launch your challenge?</h3>
        <p className={classes.subtitle}>
          Once submitted, your challenge will be visible to all selected communities, and you can edit some features.
        </p>
      </div>
    </div>
  );
};


const useSectionStyles = makeStyles((theme) => ({
    sectionBox: {
      backgroundColor: '#e6000117',
      borderRadius: '0.5rem',
      padding: '1rem',
      marginBottom: '1.5rem',
    },
    icon: {
      display: 'inline-block',
      backgroundColor: '#e6000117',
      padding: '4.5px',
      borderRadius: '50%',
      marginRight: '0.5rem',
    },
    sectionTitle: {
      fontFamily: 'VodafoneRg-bold',
      fontSize: '1.125rem',
      color: '#333',
      margin: '0.5rem 0',
    },
    sectionSubtitle: {
      fontFamily: 'VodafoneRg-regular',
      fontSize: '1rem',
      color: '#333',
    },
  }));
  
  const PreviewSection = ({ title, subtitle, data }) => {
    // console.log("🚀 ~ PreviewSection ~ data:", data)
    const classes = useSectionStyles();
  
    return (
      <div className={classes.sectionBox}>
        <div className={classes.icon}><BsInfoCircle /></div>
        <h3 className={classes.sectionTitle}>{title}</h3>
        <p className={classes.sectionSubtitle}>{subtitle}</p>
        {data.map((item,index) => (<>
          {/* {console.log("PreviewSection items",item)} */}
          <PreviewRow key={item.label || index+1} label={item.label} value={item.value} />
        </>))}
      </div>
    );
  };
  
  const useRowStyles = makeStyles(() => ({
    row: {
      display: 'grid',
      gridTemplateColumns: '40% 1fr',
      gap: '1rem',
      borderBottom: '1px solid #ccc',
      padding: '1rem 0',
    },
    text: {
      fontFamily: 'VodafoneRg-regular',
      fontSize: '1rem',
      color: '#333',
    },
  }));

const PreviewRow = ({ label, value }) => {
  const classes = useRowStyles();

  const renderValue = (val) => {
    if (val === null || val === undefined) return 'N/A';

    if (Array.isArray(val)) {
      return (
        <ul style={{ margin: 0, paddingLeft: '0rem', listStyle: 'none' }}>
          {

            (val ?? [])
              .slice()
              .sort((a, b) => {
                const la = (a && typeof a === 'object' && 'label' in a ? a.label : a) ?? '';
                const lb = (b && typeof b === 'object' && 'label' in b ? b.label : b) ?? '';
                return String(la).localeCompare(String(lb));
              })?.map((item) => (<>
                <li key={item?.id || item?.label || item?.name}>

                  {item?.src && (
                    <img
                      src={item.src}
                      alt={item.name || 'preview'}
                      style={{
                        maxWidth: '100px', height: '100px',
                        objectFit: 'cover', display: 'block'
                      }}
                    />
                  )}

                  {/* {!item?.label && !item?.src && <p>{JSON.stringify(item)}</p>} */}
                </li>

                {item?.label && (
                  <List>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>{String(item?.label)?.[0]?.toUpperCase() || "?"}</Avatar>
                      </ListItemAvatar>
                      <ListItemText > {String(item?.label) || "(unnamed)"}</ListItemText>
                    </ListItem></List>)}


              </>))}

        </ul>
      );
    }

    if (typeof val === 'object') {
      // Handle known object structures
      if (val.templateName) return val.templateName;
      if (val.label) return val.label;

      return (
        <List>
        {/* <ul style={{ margin: 0, paddingLeft: '1rem' }}> */}

          {console.log("Object.entries(val) ===> ", Object.entries(val))}
          {Object.entries(val).map(([key, nestedVal]) => (
            // <li key={key}>
            <ListItem key={key}>
              {/* <strong>{key}:</strong> {String(nestedVal)} */}
              <ListItemAvatar>
                <Avatar>{String(nestedVal)?.[0]?.toUpperCase() || "?"}</Avatar>
              </ListItemAvatar>
              <ListItemText > { String(nestedVal) || "(unnamed)"}</ListItemText>
            </ListItem>
            // </li>
          ))}
        {/* </ul> */}
        </List>
      );
    }

    return String(val);
  };

  return (
    <div className={classes.row}>
      <div className={classes.text}>{label}</div>
      <div className={classes.text}>{renderValue(value)}</div>
    </div>
  );
};

export default PreviewRow;